import React from 'react'


import {
    Card,
     } from "react-bootstrap" 

function Contact(){
    return (
        <Card className="Contact" body>Get In Touch.</Card>
    )
}

export default Contact;